<template>
    <div class="a-tile-qr" :style="componentStyles">
        <div class="a-tile-qr__content">
            <div class="a-tile-qr__qr-text" v-html="qrText">
            </div>
            <div class="a-tile-qr__qr">
                <img :src="qrLink" alt="qr">
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: "ATileQr",
    props: {
        config: {
            type: Object,
            default: null
        }
    },
    computed: {
        ...mapGetters([
            'getMapConfigProp'
        ]),
        commonConfigParams() {
            return this.getMapConfigProp('components.ATileQr.params') || {};
        },
        viewConfigParams() {
            return this.getMapConfigProp(`views.${this.view}.ATileQr.params`) || {};
        },
        commonConfigStyles() {
            return this.getMapConfigProp('components.ATileQr.styles') || {};
        },
        viewConfigStyles() {
            return this.getMapConfigProp(`views.${this.view}.ATileQr.styles`) || {};
        },
        componentStyles() {
            return {
                ...this.commonConfigStyles,
                ...this.viewConfigStyles
            }
        },
        componentParams() {
            return {
                ...this.commonConfigParams,
                ...this.viewConfigParams
            }
        },
        qrText() {
            const translateName = this.componentParams.qr_text || 'tile_qr_text'
            return this.$t(translateName)
        },
        qrLink() {
            return this.componentParams.qr_link || 'https://fs.mvgcloud.com/2459793177753146/68943145.svg'
        }
    }
}
</script>

<style lang="scss">
@import "a-tile-qr";
</style>
